import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import { api_without_cancellation } from "../../../api/api";
import TableLoader from "../../Loaders/tableLoader";
import { currencyFormat, formatDateForPanelDisplay } from "../../../Utils/helper";

const FirmReportingSettlement = ({ mainRef, controlRef, template, setReportData }) => {
  const tableRef = useRef(null);
  const [data, setData] = useState([]);
  const _userOnlineStatus = useSelector((state) => state.chat2.userOnlineStatus);

  const [availableRows, setAvailableRows] = useState(0);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!mainRef?.current || !controlRef?.current) return;

    const totalHeight = mainRef.current.getBoundingClientRect().height;
    const controlHeight = controlRef.current.getBoundingClientRect().height;
    const availableheight = totalHeight - controlHeight;
    const height = availableheight - 25;

    const rowsFromHeight = Math.floor(height / 25);
    const rowsToSubtract = data?.data?.length ?? 0;

    setAvailableRows(Math.max(0, rowsFromHeight - rowsToSubtract));
  }, [mainRef, controlRef, data]);

  const fetchTemplates = async () => {
    try {
      setLoading(true);
      const res = await api_without_cancellation.get(
        `/api/firm-reporting/firm-reporting-settlement/?template_id=${template?.id}`
      );

      const data = await res.data;
      setData(data);
      setReportData(data?.data);
    } catch (error) {
      console.error("Error fetching templates:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (template) {
      fetchTemplates();
    } else {
      setData([]);
      setReportData([]);
    }
  }, [template]);

  return (
    <>
      <div
        style={{
          overflowX: "auto",
          overflowY: "hidden",
          width: "100%",
          scrollbarWidth: "none",
        }}
        className="m-b-5 table--no-card invisible-scrollbar rounded-0 border-0 w-100 firm-reporting-table-container"
        ref={tableRef}
      >
        <table
          style={{
            overflowX: "scroll",
          }}
          className="table table-borderless settlement-table"
        >
          <thead>
            <tr
              id="report-tb-header"
              className="settle-t-4 height-25 cursor-default"
              style={{
                background: "var(--primary-10)",
                color: "var(--primary)",
              }}
            >
              <th
                className=""
                style={{
                  width: "35px",
                  minWidth: "35px",
                  maxWidth: "35px",
                  color: "var(--primary-25)",
                }}
              />

              {template && (
                <>
                  {" "}
                  <th className="td-autosize ">
                    <div className="d-flex align-items-center justify-content-center w-100 height-25">
                      Case Details
                    </div>
                  </th>
                  <th className="spacer-column" />
                </>
              )}

              {/* Dynamic columns based on selected report values */}
              {template?.settlement && (
                <>
                  <th className="td-autosize ">
                    <div className="d-flex align-items-center justify-content-center w-100 height-25">
                      Case Settlement
                    </div>
                  </th>
                  <th className="spacer-column" />
                </>
              )}

              {template?.settled && (
                <>
                  <th className="td-autosize ">
                    <div className="d-flex align-items-center justify-content-center w-100 height-25">
                      Case Settled
                    </div>
                  </th>
                  <th className="spacer-column" />
                </>
              )}

              {template?.settlement_check_received && (
                <>
                  <th className="td-autosize ">
                    <div className="d-flex align-items-center justify-content-center w-100 height-25">
                      Settlement Check Received
                    </div>
                  </th>
                  <th className="spacer-column" />
                </>
              )}

              {template?.balance_remaining_in_trust && (
                <>
                  <th className="td-autosize ">
                    <div className="d-flex align-items-center justify-content-center w-100 height-25">
                      Balance Remaining In Trust
                    </div>
                  </th>
                  <th className="spacer-column" />
                </>
              )}

              <th
                className=""
                style={{
                  width: "15px",
                  minWidth: "15px",
                  maxWidth: "15px",
                }}
              />
            </tr>
          </thead>
          <tbody id="body-table mb-1" className="table-firm-reporting">
            {loading && <TableLoader />}
            {!loading &&
              data?.data?.map((reporting, idx) => {
                return (
                  <>
                    <tr key={reporting?.id} className="cursor-default height-25">
                      <td
                        className="text-center"
                        style={{ width: "35px", color: "var(--primary-25)" }}
                      >
                        {idx + 1}
                      </td>
                      {/*  */}
                      <td className="text-start">
                        <div
                          className="d-flex align-items-center"
                          style={{
                            gap: "5px",
                            width: "max-content",
                          }}
                        >
                          <span>{reporting?.case?.for_client?.first_name}</span>
                          <span>{reporting?.case?.for_client?.last_name}</span>
                          <img
                            className="ic ic-15"
                            src={reporting?.case?.case_type?.casetype_icon}
                          />
                          <span>{reporting?.case?.case_type?.name}</span>
                        </div>
                      </td>
                      <td />
                      {template?.settlement && (
                        <>
                          <td className="text-start">
                            {/* {reporting?.offers?.map((settle) => {
                                return (
                                  <>
                                    <div className="d-flex align-items-center justify-content-start">
                                      <span>Cheque Date</span>
                                      <span>{formatDateForPanelDisplay(settle?.cheque_date)}</span>
                                    </div>
                                  </>
                                );
                              })} */}
                          </td>
                          <td className="" />
                        </>
                      )}

                      {template?.settled && (
                        <>
                          <td className="text-start">
                            {/* {reporting?.offers?.map((settle) => {
                                return (
                                  <>
                                    <div className="d-flex align-items-center justify-content-start">
                                      <span>Cheque Date</span>
                                      <span>{formatDateForPanelDisplay(settle?.cheque_date)}</span>
                                    </div>
                                  </>
                                );
                              })} */}
                          </td>
                          <td className="" />
                        </>
                      )}

                      {template?.settlement_check_received && (
                        <>
                          <td className="text-start">
                            <div className="d-flex flex-column align-items-start">
                              {reporting?.trust_checks?.map((settle) => {
                                return (
                                  <>
                                    <div className="d-flex align-items-center justify-content-start">
                                      <span>Cheque Date</span>
                                      <span>{formatDateForPanelDisplay(settle?.cheque_date)}</span>
                                    </div>
                                  </>
                                );
                              })}
                            </div>
                          </td>
                          <td className="" />
                        </>
                      )}

                      {template?.balance_remaining_in_trust && (
                        <>
                          <td className="text-start">{currencyFormat(reporting?.trust_balance)}</td>
                          <td className="" />
                        </>
                      )}

                      <td />
                    </tr>
                  </>
                );
              })}
            {Array.from({ length: Math.max(0, availableRows || 0) }).map((_, index) => (
              <tr key={`fake-row-${index}`} style={{ height: "25px" }}>
                <td colSpan={51}>&nbsp;</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default FirmReportingSettlement;
